import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SidebarLink from './SidebarLink';

import AuthContext from '../../App/authContext';

class SidebarContent extends Component {
  static propTypes = {
    changeToDark: PropTypes.func.isRequired,
    changeToLight: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  hideSidebar = () => {
    const { onClick } = this.props;
    onClick();
  };

  render() {
    return (
      <AuthContext.Consumer>
        {
          value => (
            <div className="sidebar__content">
              <ul className="sidebar__block">
                <SidebarLink title="Log out" icon="exit" route="/log_in" onClick={() => {
                  this.hideSidebar();
                  localStorage.clear();
                  value();
                }} />
              </ul>
              <ul className="sidebar__block">
                <SidebarLink title="Restaurant" route="/restaurants" onClick={this.hideSidebar} />
                <SidebarLink title="Platform" route="/platforms" onClick={this.hideSidebar} />
              </ul>
            </div>
          )
        }
      </AuthContext.Consumer>
    );
  }
}

export default SidebarContent;
